// Social Science Curriculum Data for Years 7, 9, and 10
// Based on the Vanuatu National Curriculum

export const socialScienceCurriculum = {
  "Year 7": {
    strands: [
      {
        id: 1,
        name: "History & Culture",
        color: "bg-amber-100 text-amber-800",
        topics: [
          "Introduction to Vanuatu History",
          "Traditional Ni-Vanuatu Society",
          "Family and Community Life",
          "Cultural Practices and Celebrations",
          "Introduction to Historical Inquiry"
        ]
      },
      {
        id: 2,
        name: "Geography & Environment",
        color: "bg-teal-100 text-teal-800",
        topics: [
          "Introduction to Geography",
          "Our Islands - Location and Features",
          "Weather and Seasons",
          "Local Environment",
          "Basic Map Reading"
        ]
      },
      {
        id: 3,
        name: "Civics & Citizenship",
        color: "bg-blue-100 text-blue-800",
        topics: [
          "What is a Community?",
          "Rules and Laws",
          "Being a Good Citizen",
          "Local Leaders",
          "Working Together"
        ]
      },
      {
        id: 4,
        name: "Economics & Development",
        color: "bg-green-100 text-green-800",
        topics: [
          "Needs and Wants",
          "Work in Our Community",
          "Goods and Services",
          "Money and Saving",
          "Trading and Markets"
        ]
      }
    ],
    assessments: [
      { name: "Class Activities", weight: 30 },
      { name: "Class Tests", weight: 25 },
      { name: "Projects", weight: 20 },
      { name: "Final Examination", weight: 25 }
    ]
  },
  "Year 8": {
    strands: [
      {
        id: 1,
        name: "History & Culture",
        color: "bg-amber-100 text-amber-800",
        topics: [
          "Introduction to Vanuatu History",
          "Pre-Colonial Society",
          "European Contact and Missionaries",
          "Cultural Traditions and Customs",
          "Historical Investigation Methods"
        ]
      },
      {
        id: 2,
        name: "Geography & Environment",
        color: "bg-teal-100 text-teal-800",
        topics: [
          "Geography of Vanuatu Islands",
          "Physical Features and Landforms",
          "Climate and Weather Systems",
          "Natural Resources and Land Use",
          "Map Reading and Interpretation"
        ]
      },
      {
        id: 3,
        name: "Civics & Citizenship",
        color: "bg-blue-100 text-blue-800",
        topics: [
          "Community and Society",
          "Rights and Responsibilities",
          "Local Government",
          "Being a Good Citizen",
          "Community Involvement"
        ]
      },
      {
        id: 4,
        name: "Economics & Development",
        color: "bg-green-100 text-green-800",
        topics: [
          "Understanding Economics",
          "Local Economy and Markets",
          "Work and Employment",
          "Money Management",
          "Development in Vanuatu"
        ]
      }
    ],
    assessments: [
      { name: "Class Activities", weight: 25 },
      { name: "Class Tests", weight: 30 },
      { name: "Research Project", weight: 20 },
      { name: "Final Examination", weight: 25 }
    ]
  },
  "Year 9": {
    strands: [
      {
        id: 1,
        name: "Skills of Inquiry",
        color: "bg-indigo-100 text-indigo-800",
        description: "Cross-cutting inquiry skills integrated across all schemes",
        topics: [
          "Observation and Questioning (9SOC1.1) - Analytical observations, data sources, reliability, inquiry questions",
          "Plan and Conduct an Inquiry (9SOC1.2) - Independent/collaborative work, ethical considerations, primary/secondary sources",
          "Synthesise and Select Data (9SOC1.3) - Evaluate reliability, perspectives, bias, trends and patterns",
          "Communicate and Reflect (9SOC1.4) - Justify findings, different perspectives, future planning"
        ]
      },
      {
        id: 2,
        name: "History",
        color: "bg-amber-100 text-amber-800",
        description: "Continuity, Change, Significance (9SOC2.2)",
        topics: [
          "Aftermath of WWI and Growth of Extreme Nationalism - Land alienation in Vanuatu, Wall Street Crash, Great Depression",
          "Outbreak of WWII and Events to 1941 - Rise of Fascism and Nazism, the first years of war",
          "Pearl Harbour and the Pacific War - Attack on Pearl Harbour, Pacific War to Battle of Midway",
          "Vanuatu and WWII - Americans arrive, interaction between Ni-Vanuatu and Americans",
          "Allies' Advance and End of WWII - Allies advance in Pacific and Europe, end of war",
          "Immediate Aftermath of WWII - Beginning of Cold War, formation of United Nations, Universal Declaration of Human Rights"
        ]
      },
      {
        id: 3,
        name: "Geography",
        color: "bg-teal-100 text-teal-800",
        description: "Place, Space, Environment (9SOC2.1)",
        topics: [
          "Natural Resources - What resources do we use and where do they come from?",
          "Energy Resources - Fossil fuels, non-renewable resources",
          "Renewable Resources - Renewable sources of energy, renewables in action",
          "Growing Demand for Energy - Why consumption has increased, energy sustainability",
          "Forests as Natural Resource - Deforestation, Malaysia case study"
        ]
      },
      {
        id: 4,
        name: "Economics",
        color: "bg-green-100 text-green-800",
        description: "Resources, Enterprise, Globalisation (9SOC2.3)",
        topics: [
          "Everyday Products and Services - What do we use in everyday life? Where do products come from?",
          "Imports, Exports and Tourism - Examining trade data, tourism in Vanuatu",
          "International Trade - Multinationals and transnational companies",
          "Inquiry into Transnational Companies - The current debate on transnationals",
          "Sustainability - UN Sustainable Development Goals, Vanuatu 2030 National Plan"
        ]
      },
      {
        id: 5,
        name: "Societies and Cultures",
        color: "bg-purple-100 text-purple-800",
        description: "Way of life, values and belief systems, diversity (9SOC2.4)",
        topics: [
          "Ni-Vanuatu Culture Today - Describing our culture, visitor's guide to Ni-Vanuatu society",
          "Ni-Vanuatu Culture in the Past - Independent inquiry, a picture of the past",
          "From Past to Present - What changed and why? Change for the better?",
          "Preserving Our Culture - What to prioritise, time capsule, whose responsibility?",
          "Our Future: Vanuatu +20 - How will our world look in 20 years?"
        ]
      }
    ],
    assessments: [
      { name: "Internal Examination (IE)", weight: 60, description: "Two-hour written exam per term" },
      { name: "Continuous Assessment (CA)", weight: 40, description: "Teacher Design Tasks + Common Assessment Task" }
    ]
  },
  "Year 10": {
    strands: [
      {
        id: 1,
        name: "Geography",
        color: "bg-teal-100 text-teal-800",
        topics: [
          "Understanding Geographical Processes",
          "Physical and Human Geography",
          "How Geographical Processes Impact Communities",
          "Case Study: Twin Cyclones",
          "Regional Disaster Analysis and Report Writing"
        ]
      },
      {
        id: 2,
        name: "History",
        color: "bg-amber-100 text-amber-800",
        topics: [
          "The World From 1945 to 1991",
          "Aftermaths of WW2 in Vanuatu (1944-1965)",
          "Rise of Political Parties (1965-1976)",
          "Events Towards Independence (1977 Crisis)",
          "Designing the Constitution and Independence 1980"
        ]
      },
      {
        id: 3,
        name: "Economics",
        color: "bg-green-100 text-green-800",
        topics: [
          "Introduction to Global Trade",
          "International Economic Organisations (WTO, IMF)",
          "Trade Policies and Impact on Vanuatu",
          "Role of NGOs in Economic Development",
          "Economic Opportunities and Challenges for Vanuatu"
        ]
      },
      {
        id: 4,
        name: "Society & Culture",
        color: "bg-purple-100 text-purple-800",
        topics: [
          "Impact of Globalisation on Vanuatu Culture",
          "Preserving Our Culture and Communities",
          "Cultural Inquiry and Research Methods",
          "Planning for Cultural Sustainability",
          "Traditional and Modern Practices: Coexistence"
        ]
      }
    ],
    assessments: [
      { name: "Geography Report (Geographical Processes)", weight: 25 },
      { name: "History Portfolio (Path to Independence)", weight: 25 },
      { name: "Economics Essay", weight: 20 },
      { name: "Cultural Inquiry Presentation", weight: 15 },
      { name: "Final Examination", weight: 15 }
    ]
  }
};

export const socialScienceSchemeOfWork = {
  "Year 7": {
    term1: {
      weeks: [
        { week: 1, topic: "Introduction to Social Science", activities: "Course overview, what is Social Science?" },
        { week: 2, topic: "Our Community", activities: "Understanding community, local environment" },
        { week: 3, topic: "Traditional Ni-Vanuatu Society", activities: "Clan systems, traditional roles" },
        { week: 4, topic: "Family Life", activities: "Family structures, responsibilities" },
        { week: 5, topic: "Cultural Practices", activities: "Kastom, ceremonies, celebrations" },
        { week: 6, topic: "Our Islands", activities: "Location of Vanuatu, island names" },
        { week: 7, topic: "Physical Features", activities: "Mountains, rivers, coastlines" },
        { week: 8, topic: "Weather and Seasons", activities: "Wet and dry seasons, tropical climate" },
        { week: 9, topic: "Term 1 Assessment", activities: "Class test, project work" },
        { week: 10, topic: "Review", activities: "Term review and feedback" }
      ]
    },
    term2: {
      weeks: [
        { week: 1, topic: "Our Local Environment", activities: "Flora and fauna, natural resources" },
        { week: 2, topic: "Caring for Environment", activities: "Environmental responsibility" },
        { week: 3, topic: "Basic Map Reading", activities: "Symbols, directions, simple maps" },
        { week: 4, topic: "What is a Community?", activities: "Types of communities, belonging" },
        { week: 5, topic: "Rules and Laws", activities: "Why we need rules, school rules" },
        { week: 6, topic: "Being a Good Citizen", activities: "Responsibilities, helping others" },
        { week: 7, topic: "Local Leaders", activities: "Chiefs, teachers, community leaders" },
        { week: 8, topic: "Working Together", activities: "Teamwork, community projects" },
        { week: 9, topic: "Term 2 Assessment", activities: "Class test, assignment" },
        { week: 10, topic: "Review", activities: "Term review and feedback" }
      ]
    },
    term3: {
      weeks: [
        { week: 1, topic: "Needs and Wants", activities: "Understanding difference, prioritizing" },
        { week: 2, topic: "Work in Our Community", activities: "Different jobs, importance of work" },
        { week: 3, topic: "Goods and Services", activities: "What are goods? What are services?" },
        { week: 4, topic: "Money and Saving", activities: "Purpose of money, saving habits" },
        { week: 5, topic: "Trading and Markets", activities: "Local markets, buying and selling" },
        { week: 6, topic: "Revision - History & Culture", activities: "Review of history topics" },
        { week: 7, topic: "Revision - Geography", activities: "Review of geography topics" },
        { week: 8, topic: "Revision - Civics & Economics", activities: "Review of remaining topics" },
        { week: 9, topic: "Final Examination", activities: "End of year examination" },
        { week: 10, topic: "Course Wrap-up", activities: "Results, feedback, preparation for Year 8" }
      ]
    }
  },
  "Year 8": {
    term1: {
      weeks: [
        { week: 1, topic: "Introduction to Year 8 Social Science", activities: "Course overview, building on Year 7 knowledge" },
        { week: 2, topic: "Vanuatu's Pre-Colonial Society", activities: "Traditional governance, social structures" },
        { week: 3, topic: "First European Contact", activities: "Explorers, impact on local communities" },
        { week: 4, topic: "Missionaries in Vanuatu", activities: "Christianity, changes to society" },
        { week: 5, topic: "Cultural Traditions", activities: "Kastom practices, ceremonies, oral traditions" },
        { week: 6, topic: "Geography of Vanuatu", activities: "Island chains, physical features" },
        { week: 7, topic: "Landforms and Features", activities: "Volcanoes, coral reefs, coastlines" },
        { week: 8, topic: "Climate Systems", activities: "Tropical weather, seasons, cyclones" },
        { week: 9, topic: "Term 1 Assessment", activities: "Class test, research assignment" },
        { week: 10, topic: "Review", activities: "Term review and feedback" }
      ]
    },
    term2: {
      weeks: [
        { week: 1, topic: "Natural Resources", activities: "Land, forest, marine resources" },
        { week: 2, topic: "Land Use", activities: "Agriculture, settlements, conservation" },
        { week: 3, topic: "Map Reading Skills", activities: "Scale, symbols, grid references" },
        { week: 4, topic: "Community Structures", activities: "Village organization, community roles" },
        { week: 5, topic: "Rights and Responsibilities", activities: "Individual rights, civic duties" },
        { week: 6, topic: "Local Government", activities: "Provincial councils, community leadership" },
        { week: 7, topic: "Citizenship", activities: "Being a good citizen, community service" },
        { week: 8, topic: "Community Involvement", activities: "Participating in community activities" },
        { week: 9, topic: "Term 2 Assessment", activities: "Class test, community project" },
        { week: 10, topic: "Review", activities: "Term review and feedback" }
      ]
    },
    term3: {
      weeks: [
        { week: 1, topic: "Introduction to Economics", activities: "Basic economic concepts" },
        { week: 2, topic: "Local Markets", activities: "Buying, selling, market dynamics" },
        { week: 3, topic: "Work and Employment", activities: "Types of work, employment in Vanuatu" },
        { week: 4, topic: "Money Management", activities: "Saving, budgeting, financial planning" },
        { week: 5, topic: "Development in Vanuatu", activities: "Economic development, challenges" },
        { week: 6, topic: "Revision - History & Culture", activities: "Review of history topics" },
        { week: 7, topic: "Revision - Geography", activities: "Review of geography topics" },
        { week: 8, topic: "Revision - Civics & Economics", activities: "Review of remaining topics" },
        { week: 9, topic: "Final Examination", activities: "End of year examination" },
        { week: 10, topic: "Course Wrap-up", activities: "Results, feedback, preparation for Year 9" }
      ]
    }
  },
  "Year 9": {
    term1: {
      weeks: [
        { week: 1, topic: "Introduction to Year 9 Social Science", activities: "Review of previous learning, introduction to Year 9 strands and schemes, overview of Conflict and Consequences theme", scheme: "Scheme 1: Conflict and Consequences" },
        { week: 2, topic: "Aftermath of WWI and Vanuatu", activities: "Aftermath of World War I, Vanuatu in this period - land alienation, development of nationalism in Europe", scheme: "Scheme 1: Conflict and Consequences" },
        { week: 3, topic: "Wall Street Crash and Rise of Extreme Nationalism", activities: "Wall Street Crash and Great Depression, impact on Vanuatu, growth of Fascism and Nazism. Formative Assessment A", scheme: "Scheme 1: Conflict and Consequences" },
        { week: 4, topic: "Outbreak of WWII and Events to 1941", activities: "Lead-up to WWII, 1939-1941 first years of war, attack on Pearl Harbour", scheme: "Scheme 1: Conflict and Consequences" },
        { week: 5, topic: "Pacific War and Vanuatu in WWII", activities: "Pacific War - Pearl Harbour to Midway, Americans arrive in Vanuatu, interaction between Ni-Vanuatu and Americans. Formative Assessment B", scheme: "Scheme 1: Conflict and Consequences" },
        { week: 6, topic: "Allies' Advance and End of WWII", activities: "Allies advance in Pacific and Europe, end of war in Europe and Pacific", scheme: "Scheme 1: Conflict and Consequences" },
        { week: 7, topic: "Aftermath of WWII: Cold War, UN, Human Rights", activities: "Beginning of Cold War, formation of United Nations, Universal Declaration of Human Rights", scheme: "Scheme 1: Conflict and Consequences" },
        { week: 8, topic: "Natural Resources: What Do We Use?", activities: "Resources we use, energy resources, fossil fuels, non-renewable resources", scheme: "Scheme 2: Natural Resources" },
        { week: 9, topic: "Renewable Resources and Energy Demand", activities: "Renewable energy sources, renewables in action, why energy consumption has increased, towards energy sustainability", scheme: "Scheme 2: Natural Resources" },
        { week: 10, topic: "Forests and Term 1 Summative Assessment", activities: "Forests as natural resource, deforestation case study (Malaysia). Assessment: Part 1 - Timeline/Fact file (WWI to Cold War), Part 2 - Energy proposal for Vanuatu 2035", scheme: "Scheme 2: Natural Resources" }
      ]
    },
    term2: {
      weeks: [
        { week: 1, topic: "Everyday Products: What Do We Use?", activities: "What do we use in everyday life? Introduction to products and services survey", scheme: "Scheme 1: Everyday Products and Services" },
        { week: 2, topic: "Where Do Products Come From?", activities: "Conducting a survey on product origins, examining where everyday products come from", scheme: "Scheme 1: Everyday Products and Services" },
        { week: 3, topic: "Do We Import or Export More?", activities: "Examining Vanuatu trade data, analysing import and export patterns", scheme: "Scheme 1: Everyday Products and Services" },
        { week: 4, topic: "Tourism in Vanuatu", activities: "Tourism - people and money coming into Vanuatu, economic impacts of tourism", scheme: "Scheme 1: Everyday Products and Services" },
        { week: 5, topic: "International Trade", activities: "Where in the world? Global trade routes and partners, introduction to multinationals/transnationals", scheme: "Scheme 1: Everyday Products and Services" },
        { week: 6, topic: "Multinational and Transnational Companies", activities: "Examples of transnational companies, role in international commerce, advantages and disadvantages", scheme: "Scheme 1: Everyday Products and Services" },
        { week: 7, topic: "Inquiry into Transnational Companies", activities: "Conducting an inquiry into transnationals, the current debate. Formative Assessment", scheme: "Scheme 1: Everyday Products and Services" },
        { week: 8, topic: "Sustainability: What Do We Wish to Sustain?", activities: "What do we need and want for a good life? Introduction to sustainability concepts", scheme: "Scheme 2: Sustainability" },
        { week: 9, topic: "UN Sustainable Development Goals", activities: "Background to the SDGs, examining the 17 goals, global situation data analysis", scheme: "Scheme 2: Sustainability" },
        { week: 10, topic: "Sustainability in Vanuatu and Term 2 Assessment", activities: "Current situation in Vanuatu, Vanuatu 2030 National Sustainable Development Plan. Term 2 Assessment", scheme: "Scheme 2: Sustainability" }
      ]
    },
    term3: {
      weeks: [
        { week: 1, topic: "Ni-Vanuatu Culture Today", activities: "How would we describe our culture? A visitor's guide to Ni-Vanuatu society and culture", scheme: "Scheme 1: Our Culture" },
        { week: 2, topic: "Ni-Vanuatu Culture in the Past", activities: "Independent inquiry introduction, building a picture of the past, key findings from inquiry", scheme: "Scheme 1: Our Culture" },
        { week: 3, topic: "From Past to Present", activities: "What changed and why? Change for the better? Optional consolidation - letter to the past", scheme: "Scheme 1: Our Culture" },
        { week: 4, topic: "Preserving Our Culture", activities: "What would we prioritise? A time capsule activity, how to preserve and whose responsibility?", scheme: "Scheme 1: Our Culture" },
        { week: 5, topic: "Our Culture Review and Link to Vanuatu +20", activities: "Recap of cultural themes, introduction to Our Future: Vanuatu +20 scheme", scheme: "Scheme 1: Our Culture" },
        { week: 6, topic: "Vanuatu +20: Selecting Theme and Targets", activities: "Introduction to Vanuatu +20 project, selecting inquiry theme, identifying possible targets", scheme: "Scheme 2: Our Future - Vanuatu +20" },
        { week: 7, topic: "Vanuatu +20: Planning and Conducting Inquiry", activities: "Setting Vanuatu +20 target, developing inquiry plan, conducting research", scheme: "Scheme 2: Our Future - Vanuatu +20" },
        { week: 8, topic: "Vanuatu +20: Inquiry Findings", activities: "Reviewing research findings, analysing data and information, devising presentation", scheme: "Scheme 2: Our Future - Vanuatu +20" },
        { week: 9, topic: "Vanuatu +20: Final Presentations", activities: "Presenting findings to class, peer assessment and reflection", scheme: "Scheme 2: Our Future - Vanuatu +20" },
        { week: 10, topic: "End of Year Summative Assessment", activities: "End of year assessment based on inquiry process and presentation. Course wrap-up and Year 10 preparation", scheme: "Scheme 2: Our Future - Vanuatu +20" }
      ]
    }
  },
  "Year 10": {
    term1: {
      weeks: [
        { week: 1, topic: "Introduction to Year 10 Social Science", activities: "Course overview, review of Year 9, introduction to Social Science strands" },
        { week: 2, topic: "Understanding Geographical Processes - Physical Geography", activities: "Introduction to geographical processes, physical geography concepts" },
        { week: 3, topic: "Understanding Geographical Processes - Human Geography", activities: "Human geography concepts, interaction between people and environment" },
        { week: 4, topic: "How Geographical Processes Affect Communities - Introduction", activities: "Impacts of geographical processes on communities, case studies" },
        { week: 5, topic: "How Geographical Processes Impact Communities", activities: "Detailed analysis of impacts, community responses and adaptation" },
        { week: 6, topic: "How Geographical Processes Impact Communities - Continued", activities: "Further investigation, local and regional examples" },
        { week: 7, topic: "Case Study: The Twin Cyclones", activities: "In-depth study of twin cyclones, impact analysis, community response" },
        { week: 8, topic: "The Impact of a Regional Disaster - Report Writing", activities: "Summative assessment: Writing a report on regional disaster impacts" },
        { week: 9, topic: "What is Globalisation?", activities: "Teacher-led interactive session defining globalisation, examples" },
        { week: 10, topic: "Cultural Impacts of Globalisation", activities: "How globalisation affects Vanuatu culture, positive and negative impacts" }
      ]
    },
    term2: {
      weeks: [
        { week: 1, topic: "The World and the New Hebrides From 1945 to 1990", activities: "Review of previous history learning, post-WWII world overview" },
        { week: 2, topic: "The World From 1945 to 1991 - Main Characteristics", activities: "Cold War, decolonisation movements, global changes" },
        { week: 3, topic: "The World From 1945 to 1991 - Key Events", activities: "Major world events and their impact on the Pacific region" },
        { week: 4, topic: "The Aftermaths of WW2 in Vanuatu: 1944 to 1965", activities: "Post-war changes in New Hebrides, social and political developments" },
        { week: 5, topic: "The Rise of Political Parties: 1965-1976", activities: "Formation of political parties, representative assembly" },
        { week: 6, topic: "Main Events Towards Independence: 1977 Crisis", activities: "The 1977 crisis, key events leading to independence" },
        { week: 7, topic: "Designing the Constitution", activities: "Constitutional development, principles and structure" },
        { week: 8, topic: "Independence 1980 - Assessment", activities: "Summative assessment: Primary source portfolio or documentary analysis" },
        { week: 9, topic: "Preserving Our Culture", activities: "Strategies for cultural preservation in modern Vanuatu" },
        { week: 10, topic: "Communities and Cultural Preservation", activities: "Role of communities in maintaining cultural heritage" }
      ]
    },
    term3: {
      weeks: [
        { week: 1, topic: "Case Study: The Nagol Festival", activities: "Detailed case study of Nagol (land diving), cultural significance" },
        { week: 2, topic: "Cultural Preservation Assessment", activities: "Summative assessment: Case study or report writing on cultural preservation" },
        { week: 3, topic: "Introduction to Global Trade", activities: "Global trade concepts, how international trade works" },
        { week: 4, topic: "International Economic Organisations", activities: "WTO, IMF, World Bank and their roles" },
        { week: 5, topic: "How Trade Policies Impact Vanuatu", activities: "Trade agreements, tariffs, impact on local economy" },
        { week: 6, topic: "The Role of NGOs in Economic Development", activities: "NGOs in Vanuatu, their contribution to development" },
        { week: 7, topic: "Economic Opportunities and Challenges for Vanuatu", activities: "Tourism, agriculture, fisheries, challenges facing the economy" },
        { week: 8, topic: "Economics Assessment", activities: "Summative assessment: Essay on economic issues" },
        { week: 9, topic: "Understanding Cultural Change", activities: "How and why cultures change, drivers of cultural change" },
        { week: 10, topic: "Planning a Cultural Inquiry", activities: "Research methods, developing inquiry questions" }
      ]
    },
    term4: {
      weeks: [
        { week: 1, topic: "Conducting the Cultural Inquiry", activities: "Data collection, interviews, observations" },
        { week: 2, topic: "Analysing Cultural Data", activities: "Data analysis, identifying patterns and themes" },
        { week: 3, topic: "Communicating Cultural Understanding", activities: "Presenting findings, different communication formats" },
        { week: 4, topic: "Planning for Cultural Sustainability", activities: "Developing strategies for cultural sustainability" },
        { week: 5, topic: "Traditional and Modern Practices - Coexistence or Clash", activities: "How traditional and modern practices interact in Vanuatu" },
        { week: 6, topic: "Globalisation and Vanuatu - Summary", activities: "Comprehensive review of globalisation impacts" },
        { week: 7, topic: "Revision - Geography and History", activities: "Review of all geography and history topics" },
        { week: 8, topic: "Revision - Economics and Society & Culture", activities: "Review of economics and cultural topics" },
        { week: 9, topic: "Final Examination", activities: "End of year examination" },
        { week: 10, topic: "Course Wrap-up", activities: "Results, feedback, Year 11 preparation" }
      ]
    }
  }
};

// Social Science Yearly Planner
export const socialScienceYearlyPlanner = {
  year7: {
    term1: {
      weeks: "Weeks 1-10",
      focus: "Introduction to Social Science & Culture",
      assessment: "Class Test 1 & Project",
      units: [
        {
          title: "Understanding Our Community",
          weeks: "Weeks 1-3",
          strand: "History & Culture",
          topics: ["What is Social Science?", "Our community", "Traditional society"]
        },
        {
          title: "Family and Cultural Life",
          weeks: "Weeks 4-6",
          strand: "History & Culture",
          topics: ["Family structures", "Cultural practices", "Celebrations"]
        },
        {
          title: "Our Islands",
          weeks: "Weeks 7-10",
          strand: "Geography",
          topics: ["Vanuatu location", "Physical features", "Weather and seasons"]
        }
      ]
    },
    term2: {
      weeks: "Weeks 1-10",
      focus: "Environment & Citizenship",
      assessment: "Class Test 2 & Assignment",
      units: [
        {
          title: "Our Environment",
          weeks: "Weeks 1-4",
          strand: "Geography",
          topics: ["Local environment", "Caring for nature", "Map reading"]
        },
        {
          title: "Living in Community",
          weeks: "Weeks 5-8",
          strand: "Civics",
          topics: ["Community life", "Rules and laws", "Being a good citizen"]
        },
        {
          title: "Leadership & Teamwork",
          weeks: "Weeks 9-10",
          strand: "Civics",
          topics: ["Local leaders", "Working together"]
        }
      ]
    },
    term3: {
      weeks: "Weeks 1-10",
      focus: "Economics & Revision",
      assessment: "Final Examination",
      units: [
        {
          title: "Basic Economics",
          weeks: "Weeks 1-5",
          strand: "Economics",
          topics: ["Needs and wants", "Work", "Goods and services", "Money", "Markets"]
        },
        {
          title: "Revision & Examination",
          weeks: "Weeks 6-10",
          strand: "All Strands",
          topics: ["History review", "Geography review", "Civics review", "Economics review"]
        }
      ]
    }
  },
  year9: {
    term1: {
      weeks: "Weeks 1-10",
      focus: "Conflict and Consequences (History) & Natural Resources (Geography)",
      assessment: "Summative: Part 1 - WWI to Cold War Timeline/Fact File; Part 2 - Energy Proposal for Vanuatu 2035 (IE 60% + CA 40%)",
      units: [
        {
          title: "Scheme 1: Conflict and Consequences",
          weeks: "Weeks 1-7",
          strand: "History (9SOC2.2)",
          topics: ["Introduction and review of previous learning", "Aftermath of WWI and Vanuatu land alienation", "Wall Street Crash, Great Depression, rise of Fascism/Nazism", "Outbreak of WWII and events to 1941", "Pearl Harbour, Pacific War, Vanuatu and WWII", "Allies' advance and end of WWII", "Cold War, formation of UN, Universal Declaration of Human Rights"]
        },
        {
          title: "Scheme 2: Natural Resources",
          weeks: "Weeks 8-10",
          strand: "Geography (9SOC2.1)",
          topics: ["What natural resources do we use?", "Fossil fuels and non-renewable resources", "Renewable energy sources", "Growing demand for energy", "Forests as natural resource - Malaysia deforestation case study", "Term 1 Summative Assessment"]
        }
      ]
    },
    term2: {
      weeks: "Weeks 1-10",
      focus: "Everyday Products and Services (Economics) & Sustainability",
      assessment: "Formative: Transnational Companies Inquiry; Summative: Term 2 Assessment on Trade and Sustainability",
      units: [
        {
          title: "Scheme 1: Everyday Products and Services",
          weeks: "Weeks 1-7",
          strand: "Economics (9SOC2.3)",
          topics: ["What do we use in everyday life?", "Where do products come from? Survey", "Import/export patterns in Vanuatu", "Tourism - people and money into Vanuatu", "International trade and global partners", "Multinational/transnational companies", "Inquiry into transnationals - the current debate"]
        },
        {
          title: "Scheme 2: Sustainability",
          weeks: "Weeks 8-10",
          strand: "Geography / Economics (9SOC2.1 / 9SOC2.3)",
          topics: ["What do we wish to sustain?", "UN Sustainable Development Goals", "Current global situation data analysis", "Vanuatu 2030 National Sustainable Development Plan"]
        }
      ]
    },
    term3: {
      weeks: "Weeks 1-10",
      focus: "Our Culture (Societies & Cultures) & Our Future: Vanuatu +20 (Inquiry Project)",
      assessment: "Summative: Vanuatu +20 Inquiry Presentation and End of Year Assessment",
      units: [
        {
          title: "Scheme 1: Our Culture",
          weeks: "Weeks 1-5",
          strand: "Societies and Cultures (9SOC2.4)",
          topics: ["Ni-Vanuatu culture today - describing our culture", "Visitor's guide to Ni-Vanuatu society", "Ni-Vanuatu culture in the past - independent inquiry", "From past to present - what changed and why?", "Preserving our culture - priorities, time capsule, responsibility"]
        },
        {
          title: "Scheme 2: Our Future - Vanuatu +20",
          weeks: "Weeks 6-10",
          strand: "All Strands (Cross-cutting inquiry project)",
          topics: ["Vanuatu +20 introduction and theme selection", "Setting targets and developing inquiry plan", "Conducting research and analysing findings", "Devising and delivering presentations", "End of year summative assessment"]
        }
      ]
    }
  },
  year10: {
    term1: {
      weeks: "Weeks 1-10",
      focus: "Geography: Geographical Processes & Impacts; Globalisation Introduction",
      assessment: "Written Report: Geographical Processes and Impacts (Week 8); Visual Presentation: Globalisation (Week 10)",
      units: [
        {
          title: "Geography - Geographical Process and Impacts",
          weeks: "Weeks 1-8",
          strand: "Geography",
          topics: ["Introduction to geographical processes", "Physical and human geography", "Impacts on communities", "Twin Cyclones case study", "Regional disaster report"]
        },
        {
          title: "Society and Culture - Impact of Globalisation",
          weeks: "Weeks 9-10",
          strand: "Society & Culture",
          topics: ["What is globalisation?", "Cultural impacts of globalisation"]
        }
      ]
    },
    term2: {
      weeks: "Weeks 1-10",
      focus: "History: New Hebrides to Independence; Cultural Preservation",
      assessment: "Portfolio: Vanuatu's Path to Independence (Week 8); Cultural Preservation Report (Week 10)",
      units: [
        {
          title: "History - The New Hebrides to Independence",
          weeks: "Weeks 1-8",
          strand: "History",
          topics: ["Post-WWII world", "Aftermath of WW2 in Vanuatu", "Rise of political parties", "1977 crisis", "Designing the Constitution", "Independence 1980"]
        },
        {
          title: "Society and Culture - Cultural Preservation",
          weeks: "Weeks 9-10",
          strand: "Society & Culture",
          topics: ["Preserving our culture", "Community role in cultural preservation"]
        }
      ]
    },
    term3: {
      weeks: "Weeks 1-10",
      focus: "Cultural Preservation Case Study; Economics: Global Trade & Development",
      assessment: "Cultural Case Study/Report (Week 2); Economics Essay (Week 8)",
      units: [
        {
          title: "Society and Culture - Nagol Festival Case Study",
          weeks: "Weeks 1-2",
          strand: "Society & Culture",
          topics: ["Nagol Festival case study", "Cultural preservation assessment"]
        },
        {
          title: "Economics - Global Trade and Development",
          weeks: "Weeks 3-8",
          strand: "Economics",
          topics: ["Global trade", "International economic organisations", "Trade policies impact", "NGOs in development", "Economic opportunities and challenges"]
        },
        {
          title: "Society and Culture - Cultural Change & Inquiry",
          weeks: "Weeks 9-10",
          strand: "Society & Culture",
          topics: ["Understanding cultural change", "Planning a cultural inquiry"]
        }
      ]
    },
    term4: {
      weeks: "Weeks 1-10",
      focus: "Cultural Inquiry; Globalisation Summary; End-of-Year Revision & Examination",
      assessment: "Cultural Inquiry Presentation (Week 4); Final Examination (Week 9)",
      units: [
        {
          title: "Society and Culture - Cultural Inquiry and Sustainability",
          weeks: "Weeks 1-6",
          strand: "Society & Culture",
          topics: ["Conducting cultural inquiry", "Data analysis", "Communicating findings", "Cultural sustainability", "Traditional vs modern practices", "Globalisation summary"]
        },
        {
          title: "Revision and Examination",
          weeks: "Weeks 7-10",
          strand: "All Strands",
          topics: ["Geography & history revision", "Economics & culture revision", "Final examination", "Year 11 preparation"]
        }
      ]
    }
  }
};

// Social Science Teaching Resources
export const socialScienceResources = {
  year7: [
    { title: "Year 7 Social Science Guide", type: "PDF", description: "Introduction to Social Science concepts", unit: "All" },
    { title: "Vanuatu Map Worksheets", type: "PDF", description: "Basic map reading activities", unit: "Geography" },
    { title: "Community Life Activities", type: "PDF", description: "Activities about community and citizenship", unit: "Civics" },
    { title: "Cultural Heritage Resources", type: "PDF", description: "Materials about Ni-Vanuatu culture", unit: "History" }
  ],
  year9: [
    { title: "Year 9 Teacher Guide", type: "PDF", description: "Complete Year 9 Social Science guide", unit: "All" },
    { title: "History Research Guide", type: "PDF", description: "Guide for historical research projects", unit: "History" },
    { title: "Geography Skills Workbook", type: "PDF", description: "Map skills and geography activities", unit: "Geography" },
    { title: "Civics Case Studies", type: "PDF", description: "Case studies on government and citizenship", unit: "Civics" },
    { title: "Economics Worksheets", type: "PDF", description: "Basic economics activities and exercises", unit: "Economics" }
  ],
  year10: [
    { title: "Year 10 Teacher Guide", type: "PDF", description: "Complete Year 10 Social Science guide", unit: "All" },
    { title: "Pacific History Resources", type: "PDF", description: "Resources on Pacific history and WWII", unit: "History" },
    { title: "Climate Change Materials", type: "PDF", description: "Teaching materials on climate change", unit: "Geography" },
    { title: "GIS Introduction", type: "PDF", description: "Introduction to Geographic Information Systems", unit: "Geography" },
    { title: "Entrepreneurship Guide", type: "PDF", description: "Business planning and entrepreneurship", unit: "Economics" },
    { title: "Exam Preparation Booklet", type: "PDF", description: "Past papers and exam strategies", unit: "All" }
  ]
};

// Teacher-specific resources
export const socialScienceTeacherResources = {
  'teacher-b99ecec5': [ // Kathleen Tahi - St Patrick's College
    {
      id: 'ss-guide-year9',
      name: 'Year 9 Social Science Teacher Guide',
      description: 'Complete teacher guide for Year 9 Social Science curriculum',
      url: 'https://customer-assets.emergentagent.com/job_fef6b712-b8fc-4b72-95db-2ec6aee6123b/artifacts/nnedhuzb_Year9_Social%20Science_TEACHER%20GUIDE_FINAL.pdf',
      type: 'pdf',
      year: 'Year 9'
    }
  ],
  '64c878fe-cbd2-4339-a690-8a78ff3d8535': [ // Alex Wai - Ambaebulu Junior Secondary
    {
      id: 'ss-guide-year9',
      name: 'Year 9 Social Science Teacher Guide',
      description: 'Complete teacher guide for Year 9 Social Science curriculum',
      url: 'https://customer-assets.emergentagent.com/job_fef6b712-b8fc-4b72-95db-2ec6aee6123b/artifacts/nnedhuzb_Year9_Social%20Science_TEACHER%20GUIDE_FINAL.pdf',
      type: 'pdf',
      year: 'Year 9'
    }
  ],
  'teacher-b554e14b': [ // Joel Tari - Ambaebulu Junior Secondary
    {
      id: 'ss-guide-year9',
      name: 'Year 9 Social Science Teacher Guide',
      description: 'Complete teacher guide for Year 9 Social Science curriculum',
      url: 'https://customer-assets.emergentagent.com/job_fef6b712-b8fc-4b72-95db-2ec6aee6123b/artifacts/nnedhuzb_Year9_Social%20Science_TEACHER%20GUIDE_FINAL.pdf',
      type: 'pdf',
      year: 'Year 9'
    }
  ]
};
